<template>
  <section class="agenda daythree">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Day 2 of Presentations
            </h1>
          </div>
        </div>
      </div>
      
      <daythreemorning/>
      <daythreelunch />
      <daythreeafternoon />
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda/daythree.scss';
</style>

<script>
import daythreemorning from '@/components/agenda/day-three-morning.vue';
import daythreelunch from '@/components/agenda/day-three-lunch.vue';
import daythreeafternoon from '@/components/agenda/day-three-afternoon.vue';

export default {
  name: 'daythree',
  components: {
    daythreemorning,
    daythreelunch,
    daythreeafternoon
  }
};
</script>